import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';

const UserProfileDev = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (authState?.isAuthenticated) {
      oktaAuth.getUser().then(info => {
        setUserInfo(info);
      }).catch(err => {
        console.error('Error getting user info:', err);
        // Fallback to default user if error
        setUserInfo({
          name: 'User',
          email: 'user@ischemaview.com'
        });
      });
    }
  }, [authState, oktaAuth]);

  if (!userInfo) {
    return <div>Loading user profile...</div>;
  }

  const styles = {
    profileContainer: {
      padding: '1rem',
      backgroundColor: '#f5f5f5',
      borderRadius: '8px',
      margin: '1rem',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      textAlign: 'center',
    },
    welcomeMessage: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      color: '#333',
    },
    email: {
      fontSize: '1rem',
      color: '#666',
    },
  };

  return (
    <div style={styles.profileContainer}>
      <div style={styles.welcomeMessage}>Welcome, {userInfo.name}!</div>
      <div style={styles.email}>({userInfo.email})</div>
    </div>
  );
};

export default UserProfileDev;
